import { Tooltip } from '~/components/ui/Tooltip';
import type { UserProfileProps } from '~/lib/types/netlify';

export const UserProfile = ({ user, onDisconnect }: UserProfileProps) => {
  return (
    <div className="flex items-center justify-between mb-4 bg-white/5 rounded-md p-2">
      <div className="flex items-center gap-3">
        {user.avatar ? (
          <img src={user.avatar} alt={user.name || 'User'} className="w-6 h-6 rounded-full border border-white/20" />
        ) : (
          <div className="w-6 h-6 rounded-full bg-white/10 flex items-center justify-center text-white text-xs font-medium overflow-hidden border border-white/10">
            {user.name?.charAt(0).toUpperCase() || user.email?.split('@')[0].charAt(0).toUpperCase()}
          </div>
        )}
        <div className="flex-1 min-w-0">
          {user.name && <p className="text-sm text-white font-medium leading-none m-0">{user.name}</p>}
          {user.email && <p className="text-xs text-[#888888] leading-tight m-0 mt-0.5">{user.email}</p>}
        </div>
      </div>
      <Tooltip content="Disconnect">
        <button
          onClick={onDisconnect}
          className="p-1.5 text-[#888888] hover:text-white bg-transparent 
            hover:bg-white/10 rounded-md transition-colors"
        >
          <div className="i-ph:sign-out w-4 h-4" />
        </button>
      </Tooltip>
    </div>
  );
};
